<div class="tutorial-popup-container">
  <div class="popup-header-container">
    <h2 translate="STAFF.TUTORIAL_VIDEOS.TUTORIAL_VIDEO_PROMPT_HEADING_DEFAULT"></h2>

    <gb-icon icon="close" (click)="dismiss()"></gb-icon>
  </div>

  <p>
    <span translate="STAFF.TUTORIAL_VIDEOS.TUTORIAL_VIDEO_PROMPT_DESCRIPTION_DEFAULT"></span>
    <a (click)="goToHelpCenter()" translate="STAFF.TUTORIAL_VIDEOS.HELP_CENTER"></a>
  </p>

  <!-- Video Selection Tabs (only show if multiple videos) -->
  @if (hasMultipleVideos) {
    <div class="video-tabs-container">
      @for (video of videos; track video.videoId; let i = $index) {
        <button class="video-tab" [class.active]="i === currentVideoIndex" (click)="selectVideo(i)">
          <span class="video-number">{{ i + 1 }}</span>
          <span class="video-title">{{ video.title }}</span>
        </button>
      }
    </div>
  }

  <div
    class="youtube-player-wrapper"
    [style.width.px]="playingStarted ? 600 : 400"
    [style.height.px]="playingStarted ? 340 : 225"
  >
    <youtube-player
      [width]="playingStarted ? 600 : 400"
      [height]="playingStarted ? 340 : 225"
      [videoId]="currentVideo.videoId"
      [playerVars]="playerVars"
      (stateChange)="onPlayerStateChange($event)"
    ></youtube-player>
  </div>
</div>
